import React, { useState, useEffect, useReducer } from "react";
import axios from "axios";
import {
  initialState,
  reducer,
  ACTION,
} from "../../../Reducer/InitialStateReducer";
import { Button, Modal, Popup, Icon } from "semantic-ui-react";
import { server } from "../../../App";
import { useSelector } from "react-redux";
import { selectPatientelleGrid } from "../../../features/patientelle/patientelleSlice";
import { toast } from "react-toastify";

function FormulairesAntecedents(props) {
  const [state, dispatch] = useReducer(reducer, initialState);
  const PatientelleState = useSelector(selectPatientelleGrid);

  const [count, setCount] = useState(0);

  // const { ID, pathname } = props?.ConsultationObj
  // let ID = 1
  const { IsTablet, getQuestionsOneUser22 } = props;

  const [Newstate, setNewState] = useState({
    OphtalmoVisibleametropieForte: false,
    OphtalmoVisibleastigmatisme: false,
    OphtalmoVisibleautomedication_collyre: false,
    OphtalmoVisiblechir_glaucome: false,
    OphtalmoVisiblechir_pterygion: false,
    OphtalmoVisiblechir_strabisme: false,
    OphtalmoVisiblechirurgie_de_cataracte: false,
    OphtalmoVisiblechirurgie_palpebrale: false,
    OphtalmoVisiblechirurgie_refractive: false,
    OphtalmoVisiblechirurgie_vitreo_retinienne: false,
    OphtalmoVisibledcrs: false,
    OphtalmoVisibledecollement_de_retine: false,
    OphtalmoVisibleglaucome: false,
    OphtalmoVisiblehypermetropie: false,
    OphtalmoVisibleivt_anti_vegf: false,
    OphtalmoVisiblekeratcone: false,
    OphtalmoVisiblelaser_dehiscences_retinienne: false,
    OphtalmoVisiblemyopie: false,
    OphtalmoVisibleppr: false,
    OphtalmoVisibleretinopathie_diabetique: false,
    OphtalmoVisiblestrabisme: false,
    OphtalmoVisibletraitement_amblyopie: false,
    OphtalmoVisibletraumatisme_oculaire: false,
    OphtalmoVisibletravail_prolongee_en_vp: false,
    OphtalmoVisibleautres: true,
    GenerauxVisiblecardiopathie: false,
    GenerauxVisibleallergies: false,
    GenerauxVisibletabac: false,
    GenerauxVisibledysthyroidie: false,
    GenerauxVisibleobesite: false,
    GenerauxVisibledyslipidemie: false,
    GenerauxVisiblegrossesse: false,
    GenerauxVisibleanticoagulants: false,
    GenerauxVisibleasthme: false,
    GenerauxVisiblehta: false,
    GenerauxVisiblediabete: false,
    GenerauxVisibleautres: false,
    FamiliauxVisibleAmetropie_forte: false,
    FamiliauxVisibleautres: false,
    FamiliauxVisibleglaucome: false,
    FamiliauxVisiblekeratocone: false,
    FamiliauxVisibleretinopathie: false,
    FamiliauxVisiblestrabisme: false,
    Familiauxametropie_forte: false,
    FamiliauxautresCom: "",
    Familiauxglaucome: false,
    Familiauxkeratocone: false,
    Familiauxretinopathie: false,
    Familiauxstrabisme: false,
    Generauxallergies: false,
    Generauxanticoagulants: false,
    Generauxasthme: false,
    GenerauxautresCom: "",
    Generauxcardiopathie: false,
    GenerauxdiabeteID: false,
    GenerauxdiabeteIDcom: "",
    GenerauxdiabeteNID: false,
    GenerauxdiabeteNIDcom: "",
    Generauxdyslipidemie: false,
    Generauxdysthyroidie: false,
    Generauxgrossesse: false,
    Generauxhta: false,
    Generauxobesite: false,
    Generauxtabac: false,
    OphtalmoMyopieOD: false,
    OphtalmoMyopieODcom: "",
    OphtalmoMyopieOG: false,
    OphtalmoMyopieOGcom: "",
    OphtalmoTraitement_amblyopie: false,
    OphtalmoametropieForteOD: false,
    OphtalmoametropieForteODcom: "",
    OphtalmoametropieForteOG: false,
    OphtalmoametropieForteOGcom: "",
    OphtalmoastigmatismeOD: false,
    OphtalmoastigmatismeODcom: "",
    OphtalmoastigmatismeOG: false,
    OphtalmoastigmatismeOGcom: "",
    Ophtalmoautomedication_collyreOD: false,
    Ophtalmoautomedication_collyreODcom: "",
    Ophtalmoautomedication_collyreOG: false,
    Ophtalmoautomedication_collyreOGcom: "",
    OphtalmoautresCom: "",
    Ophtalmochir_glaucomeOD: false,
    Ophtalmochir_glaucomeODcom: "",
    Ophtalmochir_glaucomeOG: false,
    Ophtalmochir_glaucomeOGcom: "",
    Ophtalmochir_pterygionOD: false,
    Ophtalmochir_pterygionODcom: "",
    Ophtalmochir_pterygionOG: false,
    Ophtalmochir_pterygionOGcom: "",
    Ophtalmochir_strabismeOD: false,
    Ophtalmochir_strabismeODcom: "",
    Ophtalmochir_strabismeOG: false,
    Ophtalmochir_strabismeOGcom: "",
    Ophtalmochirurgie_de_cataracteOD: false,
    Ophtalmochirurgie_de_cataracteODcom: "",
    Ophtalmochirurgie_de_cataracteOG: false,
    Ophtalmochirurgie_de_cataracteOGcom: "",
    Ophtalmochirurgie_palpebraleOD: false,
    Ophtalmochirurgie_palpebraleODcom: "",
    Ophtalmochirurgie_palpebraleOG: false,
    Ophtalmochirurgie_palpebraleOGcom: "",
    Ophtalmochirurgie_refractiveOD: false,
    Ophtalmochirurgie_refractiveODcom: "",
    Ophtalmochirurgie_refractiveOG: false,
    Ophtalmochirurgie_refractiveOGcom: "",
    Ophtalmochirurgie_vitreo_retinienneOD: false,
    Ophtalmochirurgie_vitreo_retinienneODcom: "",
    Ophtalmochirurgie_vitreo_retinienneOG: false,
    Ophtalmochirurgie_vitreo_retinienneOGcom: "",
    OphtalmodcrsOD: false,
    OphtalmodcrsODcom: "",
    OphtalmodcrsOG: false,
    OphtalmodcrsOGcom: "",
    Ophtalmodecollement_de_retineOD: false,
    Ophtalmodecollement_de_retineODcom: "",
    Ophtalmodecollement_de_retineOG: false,
    Ophtalmodecollement_de_retineOGcom: "",
    OphtalmoglaucomeOD: false,
    OphtalmoglaucomeODcom: "",
    OphtalmoglaucomeOG: false,
    OphtalmoglaucomeOGcom: "",
    OphtalmohypermetropieOD: false,
    OphtalmohypermetropieODcom: "",
    OphtalmohypermetropieOG: false,
    OphtalmohypermetropieOGcom: "",
    Ophtalmoivt_anti_vegfOD: false,
    Ophtalmoivt_anti_vegfODcom: "",
    Ophtalmoivt_anti_vegfOG: false,
    Ophtalmoivt_anti_vegfOGcom: "",
    OphtalmokeratconeOD: false,
    OphtalmokeratconeODcom: "",
    OphtalmokeratconeOG: false,
    OphtalmokeratconeOGcom: "",
    Ophtalmolaser_dehiscences_retinienneOD: false,
    Ophtalmolaser_dehiscences_retinienneODcom: "",
    Ophtalmolaser_dehiscences_retinienneOG: false,
    Ophtalmolaser_dehiscences_retinienneOGcom: "",
    OphtalmopprOD: false,
    OphtalmopprODcom: "",
    OphtalmopprOG: false,
    OphtalmopprOGcom: "",
    Ophtalmoretinopathie_diabetiqueOD: false,
    Ophtalmoretinopathie_diabetiqueODcom: "",
    Ophtalmoretinopathie_diabetiqueOG: false,
    Ophtalmoretinopathie_diabetiqueOGcom: "",
    OphtalmostrabismeOD: false,
    OphtalmostrabismeODcom: "",
    OphtalmostrabismeOG: false,
    OphtalmostrabismeOGcom: "",
    Ophtalmotraumatisme_oculaireOD: false,
    Ophtalmotraumatisme_oculaireODcom: "",
    Ophtalmotraumatisme_oculaireOG: false,
    Ophtalmotraumatisme_oculaireOGcom: "",
    Ophtalmotravail_prolongee_en_vpCheck: false,
  });

  useEffect(
    () => {
      setTimeout(function () {
        setCount(count + 1);
      }, 200);
    },
    // eslint-disable-next-line
    []
  );

  async function getQuestionsOneUser() {
    if (
      PatientelleState.idpatient !== undefined &&
      PatientelleState.idpatient !== ""
    ) {
      await axios
        .get(`${server}users/questions/${PatientelleState.idpatient}`, {
          headers: {
            jwtoken: sessionStorage.token,
          },
        })
        .then((response) => {
          if (response.data !== {}) {
            setNewState(response.data);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }
  useEffect(() => {
    getQuestionsOneUser();
  }, []);

  // let valueToChange = "reducePadding";
  let MakeTableGreatAgain = "customers";

  if (IsTablet) {
    // valueToChange = "DoesNotExist";
    MakeTableGreatAgain = "customers2";
  }

  // useEffect(() => {
  //     getQuestionsOneUser();

  // }, [NewData]);

  let filterTimeout;

  const handleChange = (evt) => {
    clearTimeout(filterTimeout);
    const name = evt.target.name;

    const value =
      evt.target.type === "checkbox" ? evt.target.checked : evt.target.value;
    let x;

    if (evt.target.type === "checkbox") {
      setNewState({
        ...Newstate,
        [name]: value,
      });
      x = {
        ...Newstate,
        [name]: value,
      };
      axios({
        method: "put",
        responseType: "json",
        url: `${server}users/questions/${PatientelleState.idpatient}`,
        data: x,
        headers: {
          jwtoken: sessionStorage.token,
        },
      })
        .then((response) => {
          getQuestionsOneUser();
          // toast.success("Success", {
          //   position: toast.POSITION.TOP_LEFT,
          // });
          getQuestionsOneUser22();
        })
        .catch((err) => {
          console.log(err);
          toast.error("error", {
            position: toast.POSITION.TOP_LEFT,
          });
        });
    } else {
      filterTimeout = setTimeout(() => {
        setNewState({
          ...Newstate,
          [name]: value,
        });
        x = {
          ...Newstate,
          [name]: value,
        };
        axios({
          method: "put",
          responseType: "json",
          url: `${server}users/questions/${PatientelleState.idpatient}`,
          data: x,
          headers: {
            jwtoken: sessionStorage.token,
          },
        })
          .then((response) => {
            getQuestionsOneUser();
            // toast.success("Success", {
            //   position: toast.POSITION.TOP_LEFT,
            // });
            getQuestionsOneUser22();
          })
          .catch((err) => {
            console.log(err);
            toast.error("error", {
              position: toast.POSITION.TOP_LEFT,
            });
          });
      }, 300);
    }
  };

  let menuQuestions = (
    <div className="flex-container">
      {/* <Icon name='dropdown' /> */}
      <div className="flex-item">
        <h3 className="TitreStyle">Ophtalmo personnels</h3>
        <ol>
          <li className="listeAntecedents">
            <input
              style={{
                lineHeight: "0.3rem",
                verticalAlign: "-0.2rem",
                marginRight: "0.9rem",
                width: "1.5rem",
                height: "1.5rem",
              }}
              type="checkbox"
              onChange={handleChange}
              name="OphtalmoVisibleametropieForte"
              checked={Newstate.OphtalmoVisibleametropieForte}
            />
            <label
              htmlFor="OphtalmoVisibleametropieForte"
              style={{ fontWeight: "bold", padding: "0.4rem" }}
            >
              Amétropie forte
            </label>
          </li>
          <li className="listeAntecedents">
            <input
              style={{
                lineHeight: "0.3rem",
                verticalAlign: "-0.2rem",
                marginRight: "0.9rem",
                width: "1.5rem",
                height: "1.5rem",
              }}
              type="checkbox"
              onChange={handleChange}
              name="OphtalmoVisiblemyopie"
              checked={Newstate.OphtalmoVisiblemyopie}
            />
            <label
              htmlFor="OphtalmoVisiblemyopie"
              style={{ fontWeight: "bold", padding: "0.4rem" }}
            >
              Myopie
            </label>
          </li>
          <li className="listeAntecedents">
            <input
              style={{
                lineHeight: "0.3rem",
                verticalAlign: "-0.2rem",
                marginRight: "0.9rem",
                width: "1.5rem",
                height: "1.5rem",
              }}
              type="checkbox"
              onChange={handleChange}
              name="OphtalmoVisiblehypermetropie"
              checked={Newstate.OphtalmoVisiblehypermetropie}
            />
            <label
              htmlFor="OphtalmoVisiblehypermetropie"
              style={{ fontWeight: "bold", padding: "0.4rem" }}
            >
              Hypermetropie
            </label>
          </li>
          <li className="listeAntecedents">
            <input
              style={{
                lineHeight: "0.3rem",
                verticalAlign: "-0.2rem",
                marginRight: "0.9rem",
                width: "1.5rem",
                height: "1.5rem",
              }}
              type="checkbox"
              onChange={handleChange}
              checked={Newstate.OphtalmoVisibleastigmatisme}
              name="OphtalmoVisibleastigmatisme"
            />
            <label
              htmlFor="OphtalmoVisibleastigmatisme"
              style={{ fontWeight: "bold", padding: "0.4rem" }}
            >
              Astigmatisme
            </label>
          </li>
          <li className="listeAntecedents">
            <input
              style={{
                lineHeight: "0.3rem",
                verticalAlign: "-0.2rem",
                marginRight: "0.9rem",
                width: "1.5rem",
                height: "1.5rem",
              }}
              type="checkbox"
              onChange={handleChange}
              name="OphtalmoVisibletravail_prolongee_en_vp"
              checked={Newstate.OphtalmoVisibletravail_prolongee_en_vp}
            />
            <label
              htmlFor="OphtalmoVisibletravail_prolongee_en_vp"
              style={{ fontWeight: "bold", padding: "0.4rem" }}
            >
              Trav. prolongée VP
            </label>
          </li>
          <li className="listeAntecedents">
            <input
              style={{
                lineHeight: "0.3rem",
                verticalAlign: "-0.2rem",
                marginRight: "0.9rem",
                width: "1.5rem",
                height: "1.5rem",
              }}
              type="checkbox"
              onChange={handleChange}
              name="OphtalmoVisibletraitement_amblyopie"
              checked={Newstate.OphtalmoVisibletraitement_amblyopie}
            />
            <label
              htmlFor="OphtalmoVisibletraitement_amblyopie"
              style={{ fontWeight: "bold", padding: "0.4rem" }}
            >
              Trait. d’amblyopie
            </label>
          </li>
          <li className="listeAntecedents">
            <input
              style={{
                lineHeight: "0.3rem",
                verticalAlign: "-0.2rem",
                marginRight: "0.9rem",
                width: "1.5rem",
                height: "1.5rem",
              }}
              type="checkbox"
              onChange={handleChange}
              name="OphtalmoVisibletraumatisme_oculaire"
              checked={Newstate.OphtalmoVisibletraumatisme_oculaire}
            />
            <label
              htmlFor="OphtalmoVisibletraumatisme_oculaire"
              style={{ fontWeight: "bold", padding: "0.4rem" }}
            >
              Traum. oculaire
            </label>
          </li>
          <li className="listeAntecedents">
            <input
              style={{
                lineHeight: "0.3rem",
                verticalAlign: "-0.2rem",
                marginRight: "0.9rem",
                width: "1.5rem",
                height: "1.5rem",
              }}
              type="checkbox"
              onChange={handleChange}
              name="OphtalmoVisiblekeratcone"
              checked={Newstate.OphtalmoVisiblekeratcone}
            />
            <label
              htmlFor="OphtalmoVisiblekeratcone"
              style={{ fontWeight: "bold", padding: "0.4rem" }}
            >
              Kératcone
            </label>
          </li>
          <li className="listeAntecedents">
            <input
              style={{
                lineHeight: "0.3rem",
                verticalAlign: "-0.2rem",
                marginRight: "0.9rem",
                width: "1.5rem",
                height: "1.5rem",
              }}
              type="checkbox"
              onChange={handleChange}
              name="OphtalmoVisibleglaucome"
              checked={Newstate.OphtalmoVisibleglaucome}
            />
            <label
              htmlFor="OphtalmoVisibleglaucome"
              style={{ fontWeight: "bold", padding: "0.4rem" }}
            >
              Glaucome
            </label>
          </li>
          <li className="listeAntecedents">
            <input
              style={{
                lineHeight: "0.3rem",
                verticalAlign: "-0.2rem",
                marginRight: "0.9rem",
                width: "1.5rem",
                height: "1.5rem",
              }}
              type="checkbox"
              onChange={handleChange}
              name="OphtalmoVisibleretinopathie_diabetique"
              checked={Newstate.OphtalmoVisibleretinopathie_diabetique}
            />
            <label
              htmlFor="OphtalmoVisibleretinopathie_diabetique"
              style={{ fontWeight: "bold", padding: "0.4rem" }}
            >
              Rétinopathie diab.
            </label>
          </li>
          <li className="listeAntecedents">
            <input
              style={{
                lineHeight: "0.3rem",
                verticalAlign: "-0.2rem",
                marginRight: "0.9rem",
                width: "1.5rem",
                height: "1.5rem",
              }}
              type="checkbox"
              onChange={handleChange}
              name="OphtalmoVisibleivt_anti_vegf"
              checked={Newstate.OphtalmoVisibleivt_anti_vegf}
            />
            <label
              htmlFor="OphtalmoVisibleivt_anti_vegf"
              style={{ fontWeight: "bold", padding: "0.4rem" }}
            >
              IVT d’anti-VEGF
            </label>
          </li>
          <li className="listeAntecedents">
            <input
              style={{
                lineHeight: "0.3rem",
                verticalAlign: "-0.2rem",
                marginRight: "0.9rem",
                width: "1.5rem",
                height: "1.5rem",
              }}
              type="checkbox"
              onChange={handleChange}
              name="OphtalmoVisiblestrabisme"
              checked={Newstate.OphtalmoVisiblestrabisme}
            />
            <label
              htmlFor="OphtalmoVisiblestrabisme"
              style={{ fontWeight: "bold", padding: "0.4rem" }}
            >
              Strabisme
            </label>
          </li>
          <li className="listeAntecedents">
            <input
              style={{
                lineHeight: "0.3rem",
                verticalAlign: "-0.2rem",
                marginRight: "0.9rem",
                width: "1.5rem",
                height: "1.5rem",
              }}
              type="checkbox"
              onChange={handleChange}
              name="OphtalmoVisibleautomedication_collyre"
              checked={Newstate.OphtalmoVisibleautomedication_collyre}
            />
            <label
              htmlFor="OphtalmoVisibleautomedication_collyre"
              style={{ fontWeight: "bold", padding: "0.4rem" }}
            >
              Auto Med collyre
            </label>
          </li>
          <li className="listeAntecedents">
            <input
              style={{
                lineHeight: "0.3rem",
                verticalAlign: "-0.2rem",
                marginRight: "0.9rem",
                width: "1.5rem",
                height: "1.5rem",
              }}
              type="checkbox"
              onChange={handleChange}
              name="OphtalmoVisibledecollement_de_retine"
              checked={Newstate.OphtalmoVisibledecollement_de_retine}
            />
            <label
              htmlFor="OphtalmoVisibledecollement_de_retine"
              style={{ fontWeight: "bold", padding: "0.4rem" }}
            >
              Décol. de rétine
            </label>
          </li>
        </ol>
      </div>
      {/* <div className="flex-item">

      </div>
      <div className="flex-item">

      </div>
      
       */}

      {/* 
                <input
                  style={{
                    lineHeight: "0.3rem",
                    verticalAlign: "-0.2rem",
                    marginRight: "0.9rem", width: "1.5rem",height: "1.5rem",
                  }}
                  type="checkbox" onChange={ handleChange }
                  name="OphtalmoVisibleautres"
                  checked={Newstate.OphtalmoVisibleautres}
                  onChange={() =>
                    dispatch({ type: ACTION.VISIBLEOphtalmoVisibleautres })
                  }
                />
                <label
                  htmlFor="OphtalmoVisibleautres"
                  style={{ fontWeight: "bold", padding: "0.4rem" }}
                >
                  Autres ophtalmo
                </label>
               */}

      {/* <Icon name='dropdown' /> */}

      <div className="flex-item">
        <h3 className="TitreStyle">Ophtalmo chirurgicaux </h3>
        <ol>
          <li className="listeAntecedents">
            <input
              style={{
                lineHeight: "0.3rem",
                verticalAlign: "-0.2rem",
                marginRight: "0.9rem",
                width: "1.5rem",
                height: "1.5rem",
              }}
              type="checkbox"
              onChange={handleChange}
              name="OphtalmoVisiblechir_strabisme"
              checked={Newstate.OphtalmoVisiblechir_strabisme}
            />
            <label
              htmlFor="OphtalmoVisiblechir_strabisme"
              style={{ fontWeight: "bold", padding: "0.4rem" }}
            >
              Chir. de Strabisme
            </label>
          </li>
          <li className="listeAntecedents">
            <input
              style={{
                lineHeight: "0.3rem",
                verticalAlign: "-0.2rem",
                marginRight: "0.9rem",
                width: "1.5rem",
                height: "1.5rem",
              }}
              type="checkbox"
              onChange={handleChange}
              name="OphtalmoVisiblechir_pterygion"
              checked={Newstate.OphtalmoVisiblechir_pterygion}
            />
            <label
              htmlFor="OphtalmoVisiblechir_pterygion"
              style={{ fontWeight: "bold", padding: "0.4rem" }}
            >
              Chir. de ptérygion
            </label>
          </li>
          <li className="listeAntecedents">
            <input
              style={{
                lineHeight: "0.3rem",
                verticalAlign: "-0.2rem",
                marginRight: "0.9rem",
                width: "1.5rem",
                height: "1.5rem",
              }}
              type="checkbox"
              onChange={handleChange}
              name="OphtalmoVisiblechirurgie_palpebrale"
              checked={Newstate.OphtalmoVisiblechirurgie_palpebrale}
            />
            <label
              htmlFor="OphtalmoVisiblechirurgie_palpebrale"
              style={{ fontWeight: "bold", padding: "0.4rem" }}
            >
              Chir. palpébrale
            </label>
          </li>
          <li className="listeAntecedents">
            <input
              style={{
                lineHeight: "0.3rem",
                verticalAlign: "-0.2rem",
                marginRight: "0.9rem",
                width: "1.5rem",
                height: "1.5rem",
              }}
              type="checkbox"
              onChange={handleChange}
              name="OphtalmoVisiblechir_glaucome"
              checked={Newstate.OphtalmoVisiblechir_glaucome}
            />
            <label
              htmlFor="OphtalmoVisiblechir_glaucome"
              style={{ fontWeight: "bold", padding: "0.4rem" }}
            >
              Chir. de Glaucome
            </label>
          </li>
          <li className="listeAntecedents">
            <input
              style={{
                lineHeight: "0.3rem",
                verticalAlign: "-0.2rem",
                marginRight: "0.9rem",
                width: "1.5rem",
                height: "1.5rem",
              }}
              type="checkbox"
              onChange={handleChange}
              name="OphtalmoVisiblechirurgie_vitreo_retinienne"
              checked={Newstate.OphtalmoVisiblechirurgie_vitreo_retinienne}
            />
            <label
              htmlFor="OphtalmoVisiblechirurgie_vitreo_retinienne"
              style={{ fontWeight: "bold", padding: "0.4rem" }}
            >
              Chir. vitréo-réti.
            </label>
          </li>
          <li className="listeAntecedents">
            <input
              style={{
                lineHeight: "0.3rem",
                verticalAlign: "-0.2rem",
                marginRight: "0.9rem",
                width: "1.5rem",
                height: "1.5rem",
              }}
              type="checkbox"
              onChange={handleChange}
              name="OphtalmoVisiblechirurgie_de_cataracte"
              checked={Newstate.OphtalmoVisiblechirurgie_de_cataracte}
            />
            <label
              htmlFor="OphtalmoVisiblechirurgie_de_cataracte"
              style={{ fontWeight: "bold", padding: "0.4rem" }}
            >
              Chir. de cataracte
            </label>
          </li>
          <li className="listeAntecedents">
            <input
              style={{
                lineHeight: "0.3rem",
                verticalAlign: "-0.2rem",
                marginRight: "0.9rem",
                width: "1.5rem",
                height: "1.5rem",
              }}
              type="checkbox"
              onChange={handleChange}
              name="OphtalmoVisiblechirurgie_refractive"
              checked={Newstate.OphtalmoVisiblechirurgie_refractive}
            />
            <label
              htmlFor="OphtalmoVisiblechirurgie_refractive"
              style={{ fontWeight: "bold", padding: "0.4rem" }}
            >
              Chir. réfractive
            </label>
          </li>
          <li className="listeAntecedents">
            <input
              style={{
                lineHeight: "0.3rem",
                verticalAlign: "-0.2rem",
                marginRight: "0.9rem",
                width: "1.5rem",
                height: "1.5rem",
              }}
              type="checkbox"
              onChange={handleChange}
              name="OphtalmoVisibledcrs"
              checked={Newstate.OphtalmoVisibledcrs}
            />
            <label
              htmlFor="OphtalmoVisibledcrs"
              style={{ fontWeight: "bold", padding: "0.4rem" }}
            >
              DCRS
            </label>
          </li>
          <li className="listeAntecedents">
            <input
              style={{
                lineHeight: "0.3rem",
                verticalAlign: "-0.2rem",
                marginRight: "0.9rem",
                width: "1.5rem",
                height: "1.5rem",
              }}
              type="checkbox"
              onChange={handleChange}
              name="OphtalmoVisiblelaser_dehiscences_retinienne"
              checked={Newstate.OphtalmoVisiblelaser_dehiscences_retinienne}
            />
            <label
              htmlFor="OphtalmoVisiblelaser_dehiscences_retinienne"
              style={{ fontWeight: "bold", padding: "0.4rem" }}
            >
              Laser déhiscences
            </label>
          </li>
          <li className="listeAntecedents">
            <input
              style={{
                lineHeight: "0.3rem",
                verticalAlign: "-0.2rem",
                marginRight: "0.9rem",
                width: "1.5rem",
                height: "1.5rem",
              }}
              type="checkbox"
              onChange={handleChange}
              name="OphtalmoVisibleppr"
              checked={Newstate.OphtalmoVisibleppr}
            />
            <label
              htmlFor="OphtalmoVisibleppr"
              style={{ fontWeight: "bold", padding: "0.4rem" }}
            >
              PPR
            </label>
          </li>
        </ol>
      </div>

      {/* <Icon name='dropdown' /> */}

      <div className="flex-item">
        <h3 className="TitreStyle">Personnels Généraux</h3>

        <ol>
          <li className="listeAntecedents">
            <input
              style={{
                lineHeight: "0.3rem",
                verticalAlign: "-0.2rem",
                marginRight: "0.9rem",
                width: "1.5rem",
                height: "1.5rem",
              }}
              type="checkbox"
              onChange={handleChange}
              name="GenerauxVisiblediabete"
              checked={Newstate.GenerauxVisiblediabete}
            />
            <label
              htmlFor="GenerauxVisiblediabete"
              style={{ fontWeight: "bold", padding: "0.4rem" }}
            >
              Diabète
            </label>
          </li>
          <li className="listeAntecedents">
            <input
              style={{
                lineHeight: "0.3rem",
                verticalAlign: "-0.2rem",
                marginRight: "0.9rem",
                width: "1.5rem",
                height: "1.5rem",
              }}
              type="checkbox"
              onChange={handleChange}
              name="GenerauxVisiblehta"
              checked={Newstate.GenerauxVisiblehta}
            />
            <label
              htmlFor="GenerauxVisiblehta"
              style={{ fontWeight: "bold", padding: "0.4rem" }}
            >
              HTA
            </label>
          </li>
          <li className="listeAntecedents">
            <input
              style={{
                lineHeight: "0.3rem",
                verticalAlign: "-0.2rem",
                marginRight: "0.9rem",
                width: "1.5rem",
                height: "1.5rem",
              }}
              type="checkbox"
              onChange={handleChange}
              name="GenerauxVisibleasthme"
              checked={Newstate.GenerauxVisibleasthme}
            />
            <label
              htmlFor="GenerauxVisibleasthme"
              style={{ fontWeight: "bold", padding: "0.4rem" }}
            >
              Asthme
            </label>
          </li>
          <li className="listeAntecedents">
            <input
              style={{
                lineHeight: "0.3rem",
                verticalAlign: "-0.2rem",
                marginRight: "0.9rem",
                width: "1.5rem",
                height: "1.5rem",
              }}
              type="checkbox"
              onChange={handleChange}
              name="GenerauxVisibleanticoagulants"
              checked={Newstate.GenerauxVisibleanticoagulants}
            />
            <label
              htmlFor="GenerauxVisibleanticoagulants"
              style={{ fontWeight: "bold", padding: "0.4rem" }}
            >
              Anticoagulants
            </label>
          </li>
          <li className="listeAntecedents">
            <input
              style={{
                lineHeight: "0.3rem",
                verticalAlign: "-0.2rem",
                marginRight: "0.9rem",
                width: "1.5rem",
                height: "1.5rem",
              }}
              type="checkbox"
              onChange={handleChange}
              name="GenerauxVisiblegrossesse"
              checked={Newstate.GenerauxVisiblegrossesse}
            />
            <label
              htmlFor="GenerauxVisiblegrossesse"
              style={{ fontWeight: "bold", padding: "0.4rem" }}
            >
              Grossesse
            </label>
          </li>
          <li className="listeAntecedents">
            <input
              style={{
                lineHeight: "0.3rem",
                verticalAlign: "-0.2rem",
                marginRight: "0.9rem",
                width: "1.5rem",
                height: "1.5rem",
              }}
              type="checkbox"
              onChange={handleChange}
              name="GenerauxVisibledyslipidemie"
              checked={Newstate.GenerauxVisibledyslipidemie}
            />
            <label
              htmlFor="GenerauxVisibledyslipidemie"
              style={{ fontWeight: "bold", padding: "0.4rem" }}
            >
              Dyslipidemie
            </label>
          </li>
          <li className="listeAntecedents">
            <input
              style={{
                lineHeight: "0.3rem",
                verticalAlign: "-0.2rem",
                marginRight: "0.9rem",
                width: "1.5rem",
                height: "1.5rem",
              }}
              type="checkbox"
              onChange={handleChange}
              name="GenerauxVisibleobesite"
              checked={Newstate.GenerauxVisibleobesite}
            />
            <label
              htmlFor="GenerauxVisibleobesite"
              style={{ fontWeight: "bold", padding: "0.4rem" }}
            >
              Obésité
            </label>
          </li>
          <li className="listeAntecedents">
            <input
              style={{
                lineHeight: "0.3rem",
                verticalAlign: "-0.2rem",
                marginRight: "0.9rem",
                width: "1.5rem",
                height: "1.5rem",
              }}
              type="checkbox"
              onChange={handleChange}
              name="GenerauxVisibledysthyroidie"
              checked={Newstate.GenerauxVisibledysthyroidie}
            />
            <label
              htmlFor="GenerauxVisibledysthyroidie"
              style={{ fontWeight: "bold", padding: "0.4rem" }}
            >
              Dysthyroidie
            </label>
          </li>
          <li className="listeAntecedents">
            <input
              style={{
                lineHeight: "0.3rem",
                verticalAlign: "-0.2rem",
                marginRight: "0.9rem",
                width: "1.5rem",
                height: "1.5rem",
              }}
              type="checkbox"
              onChange={handleChange}
              name="GenerauxVisibletabac"
              checked={Newstate.GenerauxVisibletabac}
            />
            <label
              htmlFor="GenerauxVisibletabac"
              style={{ fontWeight: "bold", padding: "0.4rem" }}
            >
              Tabac
            </label>
          </li>
          <li className="listeAntecedents">
            <input
              style={{
                lineHeight: "0.3rem",
                verticalAlign: "-0.2rem",
                marginRight: "0.9rem",
                width: "1.5rem",
                height: "1.5rem",
              }}
              type="checkbox"
              onChange={handleChange}
              name="GenerauxVisibleallergies"
              checked={Newstate.GenerauxVisibleallergies}
            />
            <label
              htmlFor="GenerauxVisibleallergies"
              style={{ fontWeight: "bold", padding: "0.4rem" }}
            >
              Allergies
            </label>
          </li>
          <li className="listeAntecedents">
            <input
              style={{
                lineHeight: "0.3rem",
                verticalAlign: "-0.2rem",
                marginRight: "0.9rem",
                width: "1.5rem",
                height: "1.5rem",
              }}
              type="checkbox"
              onChange={handleChange}
              name="GenerauxVisiblecardiopathie"
              checked={Newstate.GenerauxVisiblecardiopathie}
            />
            <label
              htmlFor="GenerauxVisiblecardiopathie"
              style={{ fontWeight: "bold", padding: "0.4rem" }}
            >
              Cardiopathie
            </label>
          </li>
          <li className="listeAntecedents">
            <input
              style={{
                lineHeight: "0.3rem",
                verticalAlign: "-0.2rem",
                marginRight: "0.9rem",
                width: "1.5rem",
                height: "1.5rem",
              }}
              type="checkbox"
              onChange={handleChange}
              name="GenerauxVisibleautres"
              checked={Newstate.GenerauxVisibleautres}
            />
            <label
              htmlFor="GenerauxVisibleautres"
              style={{ fontWeight: "bold", padding: "0.4rem" }}
            >
              Autres Generaux
            </label>
          </li>
        </ol>
      </div>

      <div className="flex-item">
        <h3 className="TitreStyle">Antécédents Familiaux</h3>
        <ol>
          <li className="listeAntecedents">
            <input
              style={{
                lineHeight: "0.3rem",
                verticalAlign: "-0.2rem",
                marginRight: "0.9rem",
                width: "1.5rem",
                height: "1.5rem",
              }}
              type="checkbox"
              onChange={handleChange}
              name="FamiliauxVisibleglaucome"
              checked={Newstate.FamiliauxVisibleglaucome}
            />
            <label
              htmlFor="FamiliauxVisibleglaucome"
              style={{ fontWeight: "bold", padding: "0.4rem" }}
            >
              Glaucome
            </label>
          </li>
          <li className="listeAntecedents">
            <input
              style={{
                lineHeight: "0.3rem",
                verticalAlign: "-0.2rem",
                marginRight: "0.9rem",
                width: "1.5rem",
                height: "1.5rem",
              }}
              type="checkbox"
              onChange={handleChange}
              name="FamiliauxVisiblekeratocone"
              checked={Newstate.FamiliauxVisiblekeratocone}
            />
            <label
              htmlFor="FamiliauxVisiblekeratocone"
              style={{ fontWeight: "bold", padding: "0.4rem" }}
            >
              Kératocone
            </label>
          </li>
          <li className="listeAntecedents">
            <input
              style={{
                lineHeight: "0.3rem",
                verticalAlign: "-0.2rem",
                marginRight: "0.9rem",
                width: "1.5rem",
                height: "1.5rem",
              }}
              type="checkbox"
              onChange={handleChange}
              name="FamiliauxVisiblestrabisme"
              checked={Newstate.FamiliauxVisiblestrabisme}
            />
            <label
              htmlFor="FamiliauxVisiblestrabisme"
              style={{ fontWeight: "bold", padding: "0.4rem" }}
            >
              Strabisme
            </label>
          </li>
          <li className="listeAntecedents">
            <input
              style={{
                lineHeight: "0.3rem",
                verticalAlign: "-0.2rem",
                marginRight: "0.9rem",
                width: "1.5rem",
                height: "1.5rem",
              }}
              type="checkbox"
              onChange={handleChange}
              name="FamiliauxVisibleAmetropie_forte"
              checked={Newstate.FamiliauxVisibleAmetropie_forte}
            />
            <label
              htmlFor="FamiliauxVisibleAmetropie_forte"
              style={{ fontWeight: "bold", padding: "0.4rem" }}
            >
              Amétropie forte
            </label>
          </li>
          <li className="listeAntecedents">
            <input
              style={{
                lineHeight: "0.3rem",
                verticalAlign: "-0.2rem",
                marginRight: "0.9rem",
                width: "1.5rem",
                height: "1.5rem",
              }}
              type="checkbox"
              onChange={handleChange}
              name="FamiliauxVisibleretinopathie"
              checked={Newstate.FamiliauxVisibleretinopathie}
            />
            <label
              htmlFor="FamiliauxVisibleretinopathie"
              style={{ fontWeight: "bold", padding: "0.4rem" }}
            >
              Rétinopathie
            </label>
          </li>
          <li className="listeAntecedents">
            <input
              style={{
                lineHeight: "0.3rem",
                verticalAlign: "-0.2rem",
                marginRight: "0.9rem",
                width: "1.5rem",
                height: "1.5rem",
              }}
              type="checkbox"
              onChange={handleChange}
              name="FamiliauxVisibleautres"
              checked={Newstate.FamiliauxVisibleautres}
            />
            <label
              htmlFor="FamiliauxVisibleautres"
              style={{ fontWeight: "bold", padding: "0.4rem" }}
            >
              Autres Familiaux
            </label>
          </li>
        </ol>
      </div>
      {/* <Icon name='dropdown' /> */}
    </div>
  );

  const Ophtalmologiques = {
    ametropieForte: (
      <tr>
        <td
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {/* <input
                        style={{ "lineHeight": "0.3rem", "verticalAlign": "-0.2rem", "marginRight": "0.9rem" }}
                        type="checkbox" onChange={ handleChange }
                        // hidden={true}
                        checked={Newstate.OphtalmoVisibleametropieForte}
                        name='OphtalmoVisibleametropieForte'
                    /> */}
          <label style={{ fontWeight: "bold", padding: "0.4rem" }}>
            Amétropie forte
          </label>
        </td>
        <td>
          <label style={{ fontWeight: "bold" }}>OD</label>
        </td>
        <td>
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.OphtalmoametropieForteOD}
            name="OphtalmoametropieForteOD"
          />
        </td>
        <td>
          <input
            size="7"
            style={{ borderRadius: "0.3rem" }}
            type="text"
            onChange={handleChange}
            defaultValue={Newstate.OphtalmoametropieForteODcom}
            name="OphtalmoametropieForteODcom"
          />
        </td>
        <td>
          <label style={{ fontWeight: "bold" }}>OG</label>
        </td>
        <td>
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.OphtalmoametropieForteOG}
            name="OphtalmoametropieForteOG"
          />
        </td>
        <td style={{ borderRight: "1px solid black" }}>
          <input
            type="text"
            onChange={handleChange}
            defaultValue={Newstate.OphtalmoametropieForteOGcom}
            size="7"
            style={{ borderRadius: "0.3rem" }}
            name="OphtalmoametropieForteOGcom"
          />
        </td>
      </tr>
    ),
    myopie: (
      <tr>
        <td
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {/* <input
                        style={{ "lineHeight": "0.3rem", "verticalAlign": "-0.2rem", "marginRight": "0.9rem" }}
                        type="checkbox" onChange={ handleChange }
                        // hidden={true}
                        checked={OphtalmoVisiblemyopie}
                        name='OphtalmoVisiblemyopie'
                    /> */}
          <label style={{ fontWeight: "bold", padding: "0.4rem" }}>
            Myopie
          </label>
        </td>
        <td>
          <label style={{ fontWeight: "bold" }}>OD</label>
        </td>
        <td>
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.OphtalmoMyopieOD}
            name="OphtalmoMyopieOD"
          />
        </td>
        <td>
          <input
            size="7"
            style={{ borderRadius: "0.3rem" }}
            type="text"
            onChange={handleChange}
            defaultValue={Newstate.OphtalmoMyopieODcom}
            name="OphtalmoMyopieODcom"
          />
        </td>
        <td>
          <label style={{ fontWeight: "bold" }}>OG</label>
        </td>
        <td>
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.OphtalmoMyopieOG}
            name="OphtalmoMyopieOG"
          />
        </td>
        <td style={{ borderRight: "1px solid black" }}>
          <input
            type="text"
            onChange={handleChange}
            size="7"
            style={{ borderRadius: "0.3rem" }}
            defaultValue={Newstate.OphtalmoMyopieOGcom}
            name="OphtalmoMyopieOGcom"
          />
        </td>
      </tr>
    ),
    hypermetropie: (
      <tr>
        <td
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {/* <input
                        style={{ "lineHeight": "0.3rem", "verticalAlign": "-0.2rem", "marginRight": "0.9rem" }}
                        type="checkbox" onChange={ handleChange }
                        // hidden={true}
                        checked={Newstate.OphtalmoVisiblehypermetropie}
                        name='OphtalmoVisiblehypermetropie'
                    /> */}
          <label style={{ fontWeight: "bold", padding: "0.4rem" }}>
            Hypermetropie
          </label>
        </td>
        <td>
          <label style={{ fontWeight: "bold" }}>OD</label>
        </td>
        <td>
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.OphtalmohypermetropieOD}
            name="OphtalmohypermetropieOD"
          />
        </td>
        <td>
          <input
            size="7"
            style={{ borderRadius: "0.3rem" }}
            type="text"
            onChange={handleChange}
            defaultValue={Newstate.OphtalmohypermetropieODcom}
            name="OphtalmohypermetropieODcom"
          />
        </td>
        <td>
          <label style={{ fontWeight: "bold" }}>OG</label>
        </td>
        <td>
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.OphtalmohypermetropieOG}
            name="OphtalmohypermetropieOG"
          />
        </td>
        <td style={{ borderRight: "1px solid black" }}>
          <input
            type="text"
            onChange={handleChange}
            defaultValue={Newstate.OphtalmohypermetropieOGcom}
            size="7"
            style={{ borderRadius: "0.3rem" }}
            name="OphtalmohypermetropieOGcom"
          />
        </td>
      </tr>
    ),
    astigmatisme: (
      <tr>
        <td
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {/* <input
                        style={{ "lineHeight": "0.3rem", "verticalAlign": "-0.2rem", "marginRight": "0.9rem" }}
                        type="checkbox" onChange={ handleChange }
                        // hidden={true}
                        checked={Newstate.OphtalmoVisibleastigmatisme}
                        name='OphtalmoVisibleastigmatisme'
                    /> */}
          <label style={{ fontWeight: "bold", padding: "0.4rem" }}>
            Astigmatisme
          </label>
        </td>
        <td>
          <label style={{ fontWeight: "bold" }}>OD</label>
        </td>
        <td>
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.OphtalmoastigmatismeOD}
            name="OphtalmoastigmatismeOD"
          />
        </td>
        <td>
          <input
            size="7"
            style={{ borderRadius: "0.3rem" }}
            type="text"
            onChange={handleChange}
            defaultValue={Newstate.OphtalmoastigmatismeODcom}
            name="OphtalmoastigmatismeODcom"
          />
        </td>
        <td>
          <label style={{ fontWeight: "bold" }}>OG</label>
        </td>
        <td>
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.OphtalmoastigmatismeOG}
            name="OphtalmoastigmatismeOG"
          />
        </td>
        <td style={{ borderRight: "1px solid black" }}>
          <input
            type="text"
            onChange={handleChange}
            defaultValue={Newstate.OphtalmoastigmatismeOGcom}
            size="7"
            style={{ borderRadius: "0.3rem" }}
            name="OphtalmoastigmatismeOGcom"
          />
        </td>
      </tr>
    ),
    travail_prolongee_en_vp: (
      <tr
        style={{
          borderRadius: "2rem",
        }}
      >
        <td
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        // colSpan="25%"
        >
          {/* <input
                        style={{ "lineHeight": "0.3rem", "verticalAlign": "-0.2rem", "marginRight": "0.9rem" }}
                        type="checkbox" onChange={ handleChange }
                        // hidden={true}
                        checked={Newstate.OphtalmoVisibletravail_prolongee_en_vp}
                        name='OphtalmoVisibletravail_prolongee_en_vp'
                    /> */}
          <label style={{ fontWeight: "bold", padding: "0.4rem" }}>
            Trav. prolongée VP
          </label>
        </td>
        <td colSpan="25%">
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.OphtalmoVisibletravail_prolongee_en_vp}
            name="OphtalmoVisibletravail_prolongee_en_vp"
          />
        </td>
      </tr>
    ),
    traitement_amblyopie: (
      <tr
        style={{
          borderRadius: "2rem",
        }}
      >
        <td
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        // colSpan="25%"
        >
          {/* <input
                        style={{ "lineHeight": "0.3rem", "verticalAlign": "-0.2rem", "marginRight": "0.9rem" }}
                        type="checkbox" onChange={ handleChange }
                        // hidden={true}
                        checked={Newstate.OphtalmoVisibletraitement_amblyopie}
                        name='OphtalmoVisibletraitement_amblyopie'
                    /> */}
          <label style={{ fontWeight: "bold", padding: "0.4rem" }}>
            Trait. d’amblyopie
          </label>
        </td>
        <td colSpan="25%">
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.OphtalmoVisibletraitement_amblyopie}
            name="OphtalmoVisibletraitement_amblyopie"
          />
        </td>
      </tr>
    ),
    traumatisme_oculaire: (
      <tr>
        <td
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {/* <input
                        style={{ "lineHeight": "0.3rem", "verticalAlign": "-0.2rem", "marginRight": "0.9rem" }}
                        type="checkbox" onChange={ handleChange }
                        // hidden={true}
                        checked={Newstate.OphtalmoVisibletraumatisme_oculaire}
                        name='OphtalmoVisibletraumatisme_oculaire'
                    /> */}
          <label style={{ fontWeight: "bold", padding: "0.4rem" }}>
            Traum. oculaire
          </label>
        </td>
        <td>
          <label style={{ fontWeight: "bold" }}>OD</label>
        </td>
        <td>
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.Ophtalmotraumatisme_oculaireOD}
            name="Ophtalmotraumatisme_oculaireOD"
          />
        </td>
        <td>
          <input
            size="7"
            style={{ borderRadius: "0.3rem" }}
            type="text"
            onChange={handleChange}
            defaultValue={Newstate.Ophtalmotraumatisme_oculaireODcom}
            name="Ophtalmotraumatisme_oculaireODcom"
          />
        </td>
        <td>
          <label style={{ fontWeight: "bold" }}>OG</label>
        </td>
        <td>
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.Ophtalmotraumatisme_oculaireOG}
            name="Ophtalmotraumatisme_oculaireOG"
          />
        </td>
        <td style={{ borderRight: "1px solid black" }}>
          <input
            type="text"
            onChange={handleChange}
            defaultValue={Newstate.Ophtalmotraumatisme_oculaireOGcom}
            size="7"
            style={{ borderRadius: "0.3rem" }}
            name="Ophtalmotraumatisme_oculaireOGcom"
          />
        </td>
      </tr>
    ),
    chirurgie_de_cataracte: (
      <tr>
        <td
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {/* <input
                        style={{ "lineHeight": "0.3rem", "verticalAlign": "-0.2rem", "marginRight": "0.9rem" }}
                        type="checkbox" onChange={ handleChange }
                        // hidden={true}
                        checked={Newstate.OphtalmoVisiblechirurgie_de_cataracte}
                        name='OphtalmoVisiblechirurgie_de_cataracte'
                    /> */}
          <label style={{ fontWeight: "bold", padding: "0.4rem" }}>
            Chir. de cataracte
          </label>
        </td>
        <td>
          <label style={{ fontWeight: "bold" }}>OD</label>
        </td>
        <td>
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.Ophtalmochirurgie_de_cataracteOD}
            name="Ophtalmochirurgie_de_cataracteOD"
          />
        </td>
        <td>
          <input
            size="7"
            style={{ borderRadius: "0.3rem" }}
            type="text"
            onChange={handleChange}
            defaultValue={Newstate.Ophtalmochirurgie_de_cataracteODcom}
            name="Ophtalmochirurgie_de_cataracteODcom"
          />
        </td>
        <td>
          <label style={{ fontWeight: "bold" }}>OG</label>
        </td>
        <td>
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.Ophtalmochirurgie_de_cataracteOG}
            name="Ophtalmochirurgie_de_cataracteOG"
          />
        </td>
        <td style={{ borderRight: "1px solid black" }}>
          <input
            type="text"
            onChange={handleChange}
            defaultValue={Newstate.Ophtalmochirurgie_de_cataracteOGcom}
            size="7"
            style={{ borderRadius: "0.3rem" }}
            name="Ophtalmochirurgie_de_cataracteOGcom"
          />
        </td>
      </tr>
    ),
    chirurgie_refractive: (
      <tr>
        <td
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {/* <input
                        style={{ "lineHeight": "0.3rem", "verticalAlign": "-0.2rem", "marginRight": "0.9rem" }}
                        type="checkbox" onChange={ handleChange }
                        // hidden={true}
                        checked={Newstate.OphtalmoVisiblechirurgie_refractive}
                        name='OphtalmoVisiblechirurgie_refractive'
                    /> */}
          <label style={{ fontWeight: "bold", padding: "0.4rem" }}>
            Chir. réfractive
          </label>
        </td>
        <td>
          <label style={{ fontWeight: "bold" }}>OD</label>
        </td>
        <td>
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.Ophtalmochirurgie_refractiveOD}
            name="Ophtalmochirurgie_refractiveOD"
          />
        </td>
        <td>
          <input
            size="7"
            style={{ borderRadius: "0.3rem" }}
            type="text"
            onChange={handleChange}
            defaultValue={Newstate.Ophtalmochirurgie_refractiveODcom}
            name="Ophtalmochirurgie_refractiveODcom"
          />
        </td>
        <td>
          <label style={{ fontWeight: "bold" }}>OG</label>
        </td>
        <td>
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.Ophtalmochirurgie_refractiveOG}
            name="Ophtalmochirurgie_refractiveOG"
          />
        </td>
        <td style={{ borderRight: "1px solid black" }}>
          <input
            type="text"
            onChange={handleChange}
            defaultValue={Newstate.Ophtalmochirurgie_refractiveOGcom}
            size="7"
            style={{ borderRadius: "0.3rem" }}
            name="Ophtalmochirurgie_refractiveOGcom"
          />
        </td>
      </tr>
    ),
    keratcone: (
      <tr>
        <td
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {/* <input
                        style={{ "lineHeight": "0.3rem", "verticalAlign": "-0.2rem", "marginRight": "0.9rem" }}
                        type="checkbox" onChange={ handleChange }
                        // hidden={true}
                        checked={Newstate.OphtalmoVisiblekeratcone}
                        name='OphtalmoVisiblekeratcone'
                    /> */}
          <label style={{ fontWeight: "bold", padding: "0.4rem" }}>
            Kératcone
          </label>
        </td>
        <td>
          <label style={{ fontWeight: "bold" }}>OD</label>
        </td>
        <td>
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.OphtalmokeratconeOD}
            name="OphtalmokeratconeOD"
          />
        </td>
        <td>
          <input
            size="7"
            style={{ borderRadius: "0.3rem" }}
            type="text"
            onChange={handleChange}
            defaultValue={Newstate.OphtalmokeratconeODcom}
            name="OphtalmokeratconeODcom"
          />
        </td>
        <td>
          <label style={{ fontWeight: "bold" }}>OG</label>
        </td>
        <td>
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.OphtalmokeratconeOG}
            name="OphtalmokeratconeOG"
          />
        </td>
        <td style={{ borderRight: "1px solid black" }}>
          <input
            type="text"
            onChange={handleChange}
            defaultValue={Newstate.OphtalmokeratconeOGcom}
            size="7"
            style={{ borderRadius: "0.3rem" }}
            name="OphtalmokeratconeOGcom"
          />
        </td>
      </tr>
    ),
    glaucomeOphtalmo: (
      <tr>
        <td
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {/* <input
                        style={{ "lineHeight": "0.3rem", "verticalAlign": "-0.2rem", "marginRight": "0.9rem" }}
                        type="checkbox" onChange={ handleChange }
                        // hidden={true}
                        checked={Newstate.OphtalmoVisibleglaucome}
                        name='OphtalmoVisibleglaucome'
                    /> */}
          <label style={{ fontWeight: "bold", padding: "0.4rem" }}>
            Glaucome
          </label>
        </td>
        <td>
          <label style={{ fontWeight: "bold" }}>OD</label>
        </td>
        <td>
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.OphtalmoglaucomeOD}
            name="OphtalmoglaucomeOD"
          />
        </td>
        <td>
          <input
            size="7"
            style={{ borderRadius: "0.3rem" }}
            type="text"
            onChange={handleChange}
            defaultValue={Newstate.OphtalmoglaucomeODcom}
            name="OphtalmoglaucomeODcom"
          />
        </td>
        <td>
          <label style={{ fontWeight: "bold" }}>OG</label>
        </td>
        <td>
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.OphtalmoglaucomeOG}
            name="OphtalmoglaucomeOG"
          />
        </td>
        <td style={{ borderRight: "1px solid black" }}>
          <input
            type="text"
            onChange={handleChange}
            defaultValue={Newstate.OphtalmoglaucomeOGcom}
            size="7"
            style={{ borderRadius: "0.3rem" }}
            name="OphtalmoglaucomeOGcom"
          />
        </td>
      </tr>
    ),
    chir_glaucome: (
      <tr>
        <td
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {/* <input
                        style={{ "lineHeight": "0.3rem", "verticalAlign": "-0.2rem", "marginRight": "0.9rem" }}
                        type="checkbox" onChange={ handleChange }
                        // hidden={true}
                        checked={Newstate.OphtalmoVisiblechir_glaucome}
                        name='OphtalmoVisiblechir_glaucome'
                    /> */}
          <label style={{ fontWeight: "bold", padding: "0.4rem" }}>
            Chir. de Glaucome
          </label>
        </td>
        <td>
          <label style={{ fontWeight: "bold" }}>OD</label>
        </td>
        <td>
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.Ophtalmochir_glaucomeOD}
            name="Ophtalmochir_glaucomeOD"
          />
        </td>
        <td>
          <input
            size="7"
            style={{ borderRadius: "0.3rem" }}
            type="text"
            onChange={handleChange}
            defaultValue={Newstate.Ophtalmochir_glaucomeODcom}
            name="Ophtalmochir_glaucomeODcom"
          />
        </td>
        <td>
          <label style={{ fontWeight: "bold" }}>OG</label>
        </td>
        <td>
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.Ophtalmochir_glaucomeOG}
            name="Ophtalmochir_glaucomeOG"
          />
        </td>
        <td style={{ borderRight: "1px solid black" }}>
          <input
            type="text"
            onChange={handleChange}
            defaultValue={Newstate.Ophtalmochir_glaucomeOGcom}
            size="7"
            style={{ borderRadius: "0.3rem" }}
            name="Ophtalmochir_glaucomeOGcom"
          />
        </td>
      </tr>
    ),
    decollement_de_retine: (
      <tr>
        <td
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {/* <input
                        style={{ "lineHeight": "0.3rem", "verticalAlign": "-0.2rem", "marginRight": "0.9rem" }}
                        type="checkbox" onChange={ handleChange }
                        // hidden={true}
                        checked={Newstate.OphtalmoVisibledecollement_de_retine}
                        name='OphtalmoVisibledecollement_de_retine'
                    /> */}
          <label style={{ fontWeight: "bold", padding: "0.4rem" }}>
            Décol. de rétine
          </label>
        </td>
        <td>
          <label style={{ fontWeight: "bold" }}>OD</label>
        </td>
        <td>
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.Ophtalmodecollement_de_retineOD}
            name="Ophtalmodecollement_de_retineOD"
          />
        </td>
        <td>
          <input
            size="7"
            style={{ borderRadius: "0.3rem" }}
            type="text"
            onChange={handleChange}
            defaultValue={Newstate.Ophtalmodecollement_de_retineODcom}
            name="Ophtalmodecollement_de_retineODcom"
          />
        </td>
        <td>
          <label style={{ fontWeight: "bold" }}>OG</label>
        </td>
        <td>
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.Ophtalmodecollement_de_retineOG}
            name="Ophtalmodecollement_de_retineOG"
          />
        </td>
        <td style={{ borderRight: "1px solid black" }}>
          <input
            type="text"
            onChange={handleChange}
            defaultValue={Newstate.Ophtalmodecollement_de_retineOGcom}
            size="7"
            style={{ borderRadius: "0.3rem" }}
            name="Ophtalmodecollement_de_retineOGcom"
          />
        </td>
      </tr>
    ),
    retinopathie_diabetique: (
      <tr>
        <td
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {/* <input
                        style={{ "lineHeight": "0.3rem", "verticalAlign": "-0.2rem", "marginRight": "0.9rem" }}
                        type="checkbox" onChange={ handleChange }
                        // hidden={true}
                        checked={Newstate.OphtalmoVisibleretinopathie_diabetique}
                        name='OphtalmoVisibleretinopathie_diabetique'
                    /> */}
          <label style={{ fontWeight: "bold", padding: "0.4rem" }}>
            Rétinopathie diab.
          </label>
        </td>
        <td>
          <label style={{ fontWeight: "bold" }}>OD</label>
        </td>
        <td>
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.Ophtalmoretinopathie_diabetiqueOD}
            name="Ophtalmoretinopathie_diabetiqueOD"
          />
        </td>
        <td>
          <input
            size="7"
            style={{ borderRadius: "0.3rem" }}
            type="text"
            onChange={handleChange}
            defaultValue={Newstate.Ophtalmoretinopathie_diabetiqueODcom}
            name="Ophtalmoretinopathie_diabetiqueODcom"
          />
        </td>
        <td>
          <label style={{ fontWeight: "bold" }}>OG</label>
        </td>
        <td>
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.Ophtalmoretinopathie_diabetiqueOG}
            name="Ophtalmoretinopathie_diabetiqueOG"
          />
        </td>
        <td style={{ borderRight: "1px solid black" }}>
          <input
            type="text"
            onChange={handleChange}
            defaultValue={Newstate.Ophtalmoretinopathie_diabetiqueOGcom}
            size="7"
            style={{ borderRadius: "0.3rem" }}
            name="Ophtalmoretinopathie_diabetiqueOGcom"
          />
        </td>
      </tr>
    ),
    chirurgie_vitreo_retinienne: (
      <tr>
        <td
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {/* <input
                        style={{ "lineHeight": "0.3rem", "verticalAlign": "-0.2rem", "marginRight": "0.9rem" }}
                        type="checkbox" onChange={ handleChange }
                        // hidden={true}
                        checked={Newstate.OphtalmoVisiblechirurgie_vitreo_retinienne}
                        name='OphtalmoVisiblechirurgie_vitreo_retinienne'
                    /> */}
          <label style={{ fontWeight: "bold", padding: "0.4rem" }}>
            Chir. vitréo-réti.
          </label>
        </td>
        <td>
          <label style={{ fontWeight: "bold" }}>OD</label>
        </td>
        <td>
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.Ophtalmochirurgie_vitreo_retinienneOD}
            name="Ophtalmochirurgie_vitreo_retinienneOD"
          />
        </td>
        <td>
          <input
            size="7"
            style={{ borderRadius: "0.3rem" }}
            type="text"
            onChange={handleChange}
            defaultValue={Newstate.Ophtalmochirurgie_vitreo_retinienneODcom}
            name="Ophtalmochirurgie_vitreo_retinienneODcom"
          />
        </td>
        <td>
          <label style={{ fontWeight: "bold" }}>OG</label>
        </td>
        <td>
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.Ophtalmochirurgie_vitreo_retinienneOG}
            name="Ophtalmochirurgie_vitreo_retinienneOG"
          />
        </td>
        <td style={{ borderRight: "1px solid black" }}>
          <input
            type="text"
            onChange={handleChange}
            defaultValue={Newstate.Ophtalmochirurgie_vitreo_retinienneOGcom}
            size="7"
            style={{ borderRadius: "0.3rem" }}
            name="Ophtalmochirurgie_vitreo_retinienneOGcom"
          />
        </td>
      </tr>
    ),
    laser_dehiscences_retinienne: (
      <tr>
        <td
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {/* <input
                        style={{ "lineHeight": "0.3rem", "verticalAlign": "-0.2rem", "marginRight": "0.9rem" }}
                        type="checkbox" onChange={ handleChange }
                        // hidden={true}
                        checked={Newstate.OphtalmoVisiblelaser_dehiscences_retinienne}
                        name='OphtalmoVisiblelaser_dehiscences_retinienne'
                    /> */}
          <label style={{ fontWeight: "bold", padding: "0.4rem" }}>
            Laser déhiscences
          </label>
        </td>
        <td>
          <label style={{ fontWeight: "bold" }}>OD</label>
        </td>
        <td>
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.Ophtalmolaser_dehiscences_retinienneOD}
            name="Ophtalmolaser_dehiscences_retinienneOD"
          />
        </td>
        <td>
          <input
            size="7"
            style={{ borderRadius: "0.3rem" }}
            type="text"
            onChange={handleChange}
            defaultValue={Newstate.Ophtalmolaser_dehiscences_retinienneODcom}
            name="Ophtalmolaser_dehiscences_retinienneODcom"
          />
        </td>
        <td>
          <label style={{ fontWeight: "bold" }}>OG</label>
        </td>
        <td>
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.Ophtalmolaser_dehiscences_retinienneOG}
            name="Ophtalmolaser_dehiscences_retinienneOG"
          />
        </td>
        <td style={{ borderRight: "1px solid black" }}>
          <input
            type="text"
            onChange={handleChange}
            defaultValue={Newstate.Ophtalmolaser_dehiscences_retinienneOGcom}
            size="7"
            style={{ borderRadius: "0.3rem" }}
            name="Ophtalmolaser_dehiscences_retinienneOGcom"
          />
        </td>
      </tr>
    ),
    ppr: (
      <tr>
        <td
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {/* <input
                        style={{ "lineHeight": "0.3rem", "verticalAlign": "-0.2rem", "marginRight": "0.9rem" }}
                        type="checkbox" onChange={ handleChange }
                        // hidden={true}
                        checked={Newstate.OphtalmoVisibleppr}
                        name='OphtalmoVisibleppr'
                    /> */}
          <label style={{ fontWeight: "bold", padding: "0.4rem" }}>PPR</label>
        </td>
        <td>
          <label style={{ fontWeight: "bold" }}>OD</label>
        </td>
        <td>
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.OphtalmopprOD}
            name="OphtalmopprOD"
          />
        </td>
        <td>
          <input
            size="7"
            style={{ borderRadius: "0.3rem" }}
            type="text"
            onChange={handleChange}
            defaultValue={Newstate.OphtalmopprODcom}
            name="OphtalmopprODcom"
          />
        </td>
        <td>
          <label style={{ fontWeight: "bold" }}>OG</label>
        </td>
        <td>
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.OphtalmopprOG}
            name="OphtalmopprOG"
          />
        </td>
        <td style={{ borderRight: "1px solid black" }}>
          <input
            type="text"
            onChange={handleChange}
            defaultValue={Newstate.OphtalmopprOGcom}
            size="7"
            style={{ borderRadius: "0.3rem" }}
            name="OphtalmopprOGcom"
          />
        </td>
      </tr>
    ),
    ivt_anti_vegf: (
      <tr>
        <td
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {/* <input
                        style={{ "lineHeight": "0.3rem", "verticalAlign": "-0.2rem", "marginRight": "0.9rem" }}
                        type="checkbox" onChange={ handleChange }
                        // hidden={true}
                        checked={Newstate.OphtalmoVisibleivt_anti_vegf}
                        name='OphtalmoVisibleivt_anti_vegf'
                    /> */}
          <label style={{ fontWeight: "bold", padding: "0.4rem" }}>
            IVT d’anti-VEGF
          </label>
        </td>
        <td>
          <label style={{ fontWeight: "bold" }}>OD</label>
        </td>
        <td>
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.Ophtalmoivt_anti_vegfOD}
            name="Ophtalmoivt_anti_vegfOD"
          />
        </td>
        <td>
          <input
            size="7"
            style={{ borderRadius: "0.3rem" }}
            type="text"
            onChange={handleChange}
            defaultValue={Newstate.Ophtalmoivt_anti_vegfODcom}
            name="Ophtalmoivt_anti_vegfODcom"
          />
        </td>
        <td>
          <label style={{ fontWeight: "bold" }}>OG</label>
        </td>
        <td>
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.Ophtalmoivt_anti_vegfOG}
            name="Ophtalmoivt_anti_vegfOG"
          />
        </td>
        <td style={{ borderRight: "1px solid black" }}>
          <input
            type="text"
            onChange={handleChange}
            defaultValue={Newstate.Ophtalmoivt_anti_vegfOGcom}
            size="7"
            style={{ borderRadius: "0.3rem" }}
            name="Ophtalmoivt_anti_vegfOGcom"
          />
        </td>
      </tr>
    ),
    strabismeOphtalmo: (
      <tr>
        <td
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {/* <input
                        style={{ "lineHeight": "0.3rem", "verticalAlign": "-0.2rem", "marginRight": "0.9rem" }}
                        type="checkbox" onChange={ handleChange }
                        // hidden={true}
                        checked={Newstate.OphtalmoVisiblestrabisme}
                        name='OphtalmoVisiblestrabisme'
                    /> */}
          <label style={{ fontWeight: "bold", padding: "0.4rem" }}>
            Strabisme
          </label>
        </td>
        <td>
          <label style={{ fontWeight: "bold" }}>OD</label>
        </td>
        <td>
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.OphtalmostrabismeOD}
            name="OphtalmostrabismeOD"
          />
        </td>
        <td>
          <input
            size="7"
            style={{ borderRadius: "0.3rem" }}
            type="text"
            onChange={handleChange}
            defaultValue={Newstate.OphtalmostrabismeODcom}
            name="OphtalmostrabismeODcom"
          />
        </td>
        <td>
          <label style={{ fontWeight: "bold" }}>OG</label>
        </td>
        <td>
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.OphtalmostrabismeOG}
            name="OphtalmostrabismeOG"
          />
        </td>
        <td style={{ borderRight: "1px solid black" }}>
          <input
            type="text"
            onChange={handleChange}
            defaultValue={Newstate.OphtalmostrabismeOGcom}
            size="7"
            style={{ borderRadius: "0.3rem" }}
            name="OphtalmostrabismeOGcom"
          />
        </td>
      </tr>
    ),
    chir_strabisme: (
      <tr>
        <td
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {/* <input
                        style={{ "lineHeight": "0.3rem", "verticalAlign": "-0.2rem", "marginRight": "0.9rem" }}
                        type="checkbox" onChange={ handleChange }
                        // hidden={true}
                        checked={Newstate.OphtalmoVisiblechir_strabisme}
                        name='OphtalmoVisiblechir_strabisme'
                    /> */}
          <label style={{ fontWeight: "bold", padding: "0.4rem" }}>
            Chir. de Strabisme
          </label>
        </td>
        <td>
          <label style={{ fontWeight: "bold" }}>OD</label>
        </td>
        <td>
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.Ophtalmochir_strabismeOD}
            name="Ophtalmochir_strabismeOD"
          />
        </td>
        <td>
          <input
            size="7"
            style={{ borderRadius: "0.3rem" }}
            type="text"
            onChange={handleChange}
            defaultValue={Newstate.Ophtalmochir_strabismeODcom}
            name="Ophtalmochir_strabismeODcom"
          />
        </td>
        <td>
          <label style={{ fontWeight: "bold" }}>OG</label>
        </td>
        <td>
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.Ophtalmochir_strabismeOG}
            name="Ophtalmochir_strabismeOG"
          />
        </td>
        <td style={{ borderRight: "1px solid black" }}>
          <input
            type="text"
            onChange={handleChange}
            defaultValue={Newstate.Ophtalmochir_strabismeOGcom}
            size="7"
            style={{ borderRadius: "0.3rem" }}
            name="Ophtalmochir_strabismeOGcom"
          />
        </td>
      </tr>
    ),
    chir_pterygion: (
      <tr>
        <td
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {/* <input
                        style={{ "lineHeight": "0.3rem", "verticalAlign": "-0.2rem", "marginRight": "0.9rem" }}
                        type="checkbox" onChange={ handleChange }
                        // hidden={true}
                        checked={Newstate.OphtalmoVisiblechir_pterygion}
                        name='OphtalmoVisiblechir_pterygion'
                    /> */}
          <label style={{ fontWeight: "bold", padding: "0.4rem" }}>
            Chir. de ptérygion
          </label>
        </td>
        <td>
          <label style={{ fontWeight: "bold" }}>OD</label>
        </td>
        <td>
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.Ophtalmochir_pterygionOD}
            name="Ophtalmochir_pterygionOD"
          />
        </td>
        <td>
          <input
            size="7"
            style={{ borderRadius: "0.3rem" }}
            type="text"
            onChange={handleChange}
            defaultValue={Newstate.Ophtalmochir_pterygionODcom}
            name="Ophtalmochir_pterygionODcom"
          />
        </td>
        <td>
          <label style={{ fontWeight: "bold" }}>OG</label>
        </td>
        <td>
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.Ophtalmochir_pterygionOG}
            name="Ophtalmochir_pterygionOG"
          />
        </td>
        <td style={{ borderRight: "1px solid black" }}>
          <input
            type="text"
            onChange={handleChange}
            defaultValue={Newstate.Ophtalmochir_pterygionOGcom}
            size="7"
            style={{ borderRadius: "0.3rem" }}
            name="Ophtalmochir_pterygionOGcom"
          />
        </td>
      </tr>
    ),

    dcrs: (
      <tr>
        <td
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {/* <input
                        style={{ "lineHeight": "0.3rem", "verticalAlign": "-0.2rem", "marginRight": "0.9rem" }}
                        type="checkbox" onChange={ handleChange }
                        // hidden={true}
                        checked={Newstate.OphtalmoVisibledcrs}
                        name='OphtalmoVisibledcrs'
                    /> */}
          <label style={{ fontWeight: "bold", padding: "0.4rem" }}>DCRS</label>
        </td>
        <td>
          <label style={{ fontWeight: "bold" }}>OD</label>
        </td>
        <td>
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.OphtalmodcrsOD}
            name="OphtalmodcrsOD"
          />
        </td>
        <td>
          <input
            size="7"
            style={{ borderRadius: "0.3rem" }}
            type="text"
            onChange={handleChange}
            defaultValue={Newstate.OphtalmodcrsODcom}
            name="OphtalmodcrsODcom"
          />
        </td>
        <td>
          <label style={{ fontWeight: "bold" }}>OG</label>
        </td>
        <td>
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.OphtalmodcrsOG}
            name="OphtalmodcrsOG"
          />
        </td>
        <td style={{ borderRight: "1px solid black" }}>
          <input
            type="text"
            onChange={handleChange}
            defaultValue={Newstate.OphtalmodcrsOGcom}
            size="7"
            style={{ borderRadius: "0.3rem" }}
            name="OphtalmodcrsOGcom"
          />
        </td>
      </tr>
    ),
    chirurgie_palpebrale: (
      <tr>
        <td
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {/* <input
                        style={{ "lineHeight": "0.3rem", "verticalAlign": "-0.2rem", "marginRight": "0.9rem" }}
                        type="checkbox" onChange={ handleChange }
                        // hidden={true}
                        checked={Newstate.OphtalmoVisiblechirurgie_palpebrale}
                        name='OphtalmoVisiblechirurgie_palpebrale'
                    /> */}
          <label style={{ fontWeight: "bold", padding: "0.4rem" }}>
            Chir. palpébrale
          </label>
        </td>
        <td>
          <label style={{ fontWeight: "bold" }}>OD</label>
        </td>
        <td>
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.Ophtalmochirurgie_palpebraleOD}
            name="Ophtalmochirurgie_palpebraleOD"
          />
        </td>
        <td>
          <input
            size="7"
            style={{ borderRadius: "0.3rem" }}
            type="text"
            onChange={handleChange}
            defaultValue={Newstate.Ophtalmochirurgie_palpebraleODcom}
            name="Ophtalmochirurgie_palpebraleODcom"
          />
        </td>
        <td>
          <label style={{ fontWeight: "bold" }}>OG</label>
        </td>
        <td>
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.Ophtalmochirurgie_palpebraleOG}
            name="Ophtalmochirurgie_palpebraleOG"
          />
        </td>
        <td style={{ borderRight: "1px solid black" }}>
          <input
            type="text"
            onChange={handleChange}
            defaultValue={Newstate.Ophtalmochirurgie_palpebraleOGcom}
            size="7"
            style={{ borderRadius: "0.3rem" }}
            name="Ophtalmochirurgie_palpebraleOGcom"
          />
        </td>
      </tr>
    ),
    automedication_par_collyre: (
      <tr>
        <td
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {/* <input
                        style={{ "lineHeight": "0.3rem", "verticalAlign": "-0.2rem", "marginRight": "0.9rem" }}
                        type="checkbox" onChange={ handleChange }
                        // hidden={true}
                        checked={Newstate.OphtalmoVisibleautomedication_collyre}
                        name='OphtalmoVisibleautomedication_collyre'
                    /> */}
          <label style={{ fontWeight: "bold", padding: "0.4rem" }}>
            Auto Med collyre
          </label>
        </td>
        <td>
          <label style={{ fontWeight: "bold" }}>OD</label>
        </td>
        <td>
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.Ophtalmoautomedication_collyreOD}
            name="Ophtalmoautomedication_collyreOD"
          />
        </td>
        <td>
          <input
            size="7"
            style={{ borderRadius: "0.3rem" }}
            type="text"
            onChange={handleChange}
            defaultValue={Newstate.Ophtalmoautomedication_collyreODcom}
            name="Ophtalmoautomedication_collyreODcom"
          />
        </td>
        <td>
          <label style={{ fontWeight: "bold" }}>OG</label>
        </td>
        <td>
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.Ophtalmoautomedication_collyreOG}
            name="Ophtalmoautomedication_collyreOG"
          />
        </td>
        <td style={{ borderRight: "1px solid black" }}>
          <input
            type="text"
            onChange={handleChange}
            defaultValue={Newstate.Ophtalmoautomedication_collyreOGcom}
            size="7"
            style={{ borderRadius: "0.3rem" }}
            name="Ophtalmoautomedication_collyreOGcom"
          />
        </td>
      </tr>
    ),
    autresOphtalmologiques: (
      <tr
        style={{
          borderRadius: "2rem",
        }}
      >
        <td
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {/* <input
                        style={{ "lineHeight": "0.3rem", "verticalAlign": "-0.2rem", "marginRight": "0.9rem" }}
                        type="checkbox" onChange={ handleChange }
                        // hidden={true}
                        checked={Newstate.OphtalmoVisibleautres}
                        name='OphtalmoVisibleautres'
                    /> */}
          <label style={{ fontWeight: "bold", padding: "0.4rem" }}>
            Autres
          </label>
        </td>
        <td colSpan="25%">
          <textarea
            rows="4"
            cols="42"
            style={{ borderRadius: "0.3rem" }}
            defaultValue={Newstate.OphtalmoautresCom}
            name="OphtalmoautresCom"
            onChange={handleChange}
          />
        </td>
      </tr>
    ),
  };
  const Generaux = {
    diabete: (
      <tr>
        <td
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {/* <input
                        style={{ "lineHeight": "0.3rem", "verticalAlign": "-0.2rem", "marginRight": "0.9rem" }}
                        type="checkbox" onChange={ handleChange }
                        // hidden={true}
                        checked={Newstate.GenerauxVisiblediabete}
                        name='GenerauxVisiblediabete'
                    /> */}
          <label style={{ fontWeight: "bold", padding: "0.4rem" }}>
            Diabète
          </label>
        </td>
        <td>
          <label style={{ fontWeight: "bold" }}>Type 2</label>
        </td>
        <td>
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.GenerauxdiabeteNID}
            name="GenerauxdiabeteNID"
          />
        </td>
        <td>
          <input
            size="7"
            style={{ borderRadius: "0.3rem" }}
            type="text"
            onChange={handleChange}
            defaultValue={Newstate.GenerauxdiabeteNIDcom}
            name="GenerauxdiabeteNIDcom"
          />
        </td>
        <td>
          <label style={{ fontWeight: "bold" }}>Type 1</label>
        </td>
        <td>
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.GenerauxdiabeteID}
            name="GenerauxdiabeteID"
          />
        </td>
        <td style={{ borderRight: "1px solid black" }}>
          <input
            type="text"
            onChange={handleChange}
            defaultValue={Newstate.GenerauxdiabeteIDcom}
            size="7"
            style={{ borderRadius: "0.3rem" }}
            name="GenerauxdiabeteIDcom"
          />
        </td>
      </tr>
    ),
    hta: (
      <tr
        style={{
          borderRadius: "2rem",
        }}
      >
        <td
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        // colSpan="25%"
        >
          {/* <input
                        style={{ "lineHeight": "0.3rem", "verticalAlign": "-0.2rem", "marginRight": "0.9rem" }}
                        type="checkbox" onChange={ handleChange }
                        // hidden={true}
                        checked={Newstate.GenerauxVisiblehta}
                        name='GenerauxVisiblehta'
                    /> */}
          <label style={{ fontWeight: "bold", padding: "0.4rem" }}>HTA</label>
        </td>
        <td colSpan="25%">
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.GenerauxVisiblehta}
            name="GenerauxVisiblehta"
          />
        </td>
      </tr>
    ),
    asthme: (
      <tr
        style={{
          borderRadius: "2rem",
        }}
      >
        <td
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        // colSpan="25%"
        >
          {/* <input
                        style={{ "lineHeight": "0.3rem", "verticalAlign": "-0.2rem", "marginRight": "0.9rem" }}
                        type="checkbox" onChange={ handleChange }
                        // hidden={true}
                        checked={Newstate.GenerauxVisibleasthme}
                        name='GenerauxVisibleasthme'
                    /> */}
          <label style={{ fontWeight: "bold", padding: "0.4rem" }}>
            Asthme
          </label>
        </td>
        <td colSpan="25%">
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.GenerauxVisibleasthme}
            name="GenerauxVisibleasthme"
          />
        </td>
      </tr>
    ),
    anticoagulants: (
      <tr
        style={{
          borderRadius: "2rem",
        }}
      >
        <td
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        // colSpan="25%"
        >
          {/* <input
                        style={{ "lineHeight": "0.3rem", "verticalAlign": "-0.2rem", "marginRight": "0.9rem" }}
                        type="checkbox" onChange={ handleChange }
                        // hidden={true}
                        checked={Newstate.GenerauxVisibleanticoagulants}
                        name='GenerauxVisibleanticoagulants'
                    /> */}
          <label style={{ fontWeight: "bold", padding: "0.4rem" }}>
            Anticoagulants
          </label>
        </td>
        <td colSpan="25%">
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.GenerauxVisibleanticoagulants}
            name="GenerauxVisibleanticoagulants"
          />
        </td>
      </tr>
    ),
    grossesse: (
      <tr
        style={{
          borderRadius: "2rem",
        }}
      >
        <td
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        // colSpan="25%"
        >
          {/* <input
                        style={{ "lineHeight": "0.3rem", "verticalAlign": "-0.2rem", "marginRight": "0.9rem" }}
                        type="checkbox" onChange={ handleChange }
                        // hidden={true}
                        checked={Newstate.GenerauxVisiblegrossesse}
                        name='GenerauxVisiblegrossesse'
                    /> */}
          <label style={{ fontWeight: "bold", padding: "0.4rem" }}>
            Grossesse
          </label>
        </td>
        <td colSpan="25%">
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.GenerauxVisiblegrossesse}
            name="GenerauxVisiblegrossesse"
          />
        </td>
      </tr>
    ),
    dyslipidemie: (
      <tr
        style={{
          borderRadius: "2rem",
        }}
      >
        <td
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        // colSpan="25%"
        >
          {/* <input
                        style={{ "lineHeight": "0.3rem", "verticalAlign": "-0.2rem", "marginRight": "0.9rem" }}
                        type="checkbox" onChange={ handleChange }
                        // hidden={true}
                        checked={Newstate.GenerauxVisibledyslipidemie}
                        name='GenerauxVisibledyslipidemie'
                    /> */}
          <label style={{ fontWeight: "bold", padding: "0.4rem" }}>
            Dyslipidemie
          </label>
        </td>
        <td colSpan="25%">
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.GenerauxVisibledyslipidemie}
            name="GenerauxVisibledyslipidemie"
          />
        </td>
      </tr>
    ),
    obesite: (
      <tr
        style={{
          borderRadius: "2rem",
        }}
      >
        <td
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        // colSpan="25%"
        >
          {/* <input
                        style={{ "lineHeight": "0.3rem", "verticalAlign": "-0.2rem", "marginRight": "0.9rem" }}
                        type="checkbox" onChange={ handleChange }
                        // hidden={true}
                        checked={Newstate.GenerauxVisibleobesite}
                        name='GenerauxVisibleobesite'
                    /> */}
          <label style={{ fontWeight: "bold", padding: "0.4rem" }}>
            Obésité
          </label>
        </td>
        <td colSpan="25%">
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.GenerauxVisibleobesite}
            name="GenerauxVisibleobesite"
          />
        </td>
      </tr>
    ),
    dysthyroidie: (
      <tr
        style={{
          borderRadius: "2rem",
        }}
      >
        <td
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        // colSpan="25%"
        >
          {/* <input
                        style={{ "lineHeight": "0.3rem", "verticalAlign": "-0.2rem", "marginRight": "0.9rem" }}
                        type="checkbox" onChange={ handleChange }
                        // hidden={true}
                        checked={Newstate.GenerauxVisibledysthyroidie}
                        name='GenerauxVisibledysthyroidie'
                    /> */}
          <label style={{ fontWeight: "bold", padding: "0.4rem" }}>
            Dysthyroidie
          </label>
        </td>
        <td colSpan="25%">
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.GenerauxVisibledysthyroidie}
            name="GenerauxVisibledysthyroidie"
          />
        </td>
      </tr>
    ),
    tabac: (
      <tr
        style={{
          borderRadius: "2rem",
        }}
      >
        <td
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        // colSpan="25%"
        >
          {/* <input
                        style={{ "lineHeight": "0.3rem", "verticalAlign": "-0.2rem", "marginRight": "0.9rem" }}
                        type="checkbox" onChange={ handleChange }
                        // hidden={true}
                        checked={Newstate.GenerauxVisibletabac}
                        name='GenerauxVisibletabac'
                    /> */}
          <label style={{ fontWeight: "bold", padding: "0.4rem" }}>Tabac</label>
        </td>
        <td colSpan="25%">
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.GenerauxVisibletabac}
            name="GenerauxVisibletabac"
          />
        </td>
      </tr>
    ),
    allergies: (
      <tr
        style={{
          borderRadius: "2rem",
        }}
      >
        <td
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        // colSpan="25%"
        >
          {/* <input
                        style={{ "lineHeight": "0.3rem", "verticalAlign": "-0.2rem", "marginRight": "0.9rem" }}
                        type="checkbox" onChange={ handleChange }
                        // hidden={true}
                        checked={Newstate.GenerauxVisibleallergies}
                        name='GenerauxVisibleallergies'
                    /> */}
          <label style={{ fontWeight: "bold", padding: "0.4rem" }}>
            Allergies
          </label>
        </td>
        <td colSpan="25%">
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.GenerauxVisibleallergies}
            name="GenerauxVisibleallergies"
          />
        </td>
      </tr>
    ),
    cardiopathie: (
      <tr
        style={{
          borderRadius: "2rem",
        }}
      >
        <td
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        // colSpan="25%"
        >
          {/* <input
                        style={{ "lineHeight": "0.3rem", "verticalAlign": "-0.2rem", "marginRight": "0.9rem" }}
                        type="checkbox" onChange={ handleChange }
                        // hidden={true}
                        checked={Newstate.GenerauxVisiblecardiopathie}
                        name='GenerauxVisiblecardiopathie'
                    /> */}
          <label style={{ fontWeight: "bold", padding: "0.4rem" }}>
            Cardiopathie
          </label>
        </td>
        <td colSpan="25%">
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.GenerauxVisiblecardiopathie}
            name="GenerauxVisiblecardiopathie"
          />
        </td>
      </tr>
    ),
    autresGeneraux: (
      <tr
        style={{
          borderRadius: "2rem",
        }}
      >
        <td
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {/* <input
                        style={{ "lineHeight": "0.3rem", "verticalAlign": "-0.2rem", "marginRight": "0.9rem" }}
                        type="checkbox" onChange={ handleChange }
                        // hidden={true}
                        checked={Newstate.GenerauxVisibleautres}
                        name='GenerauxVisibleautres'
                    /> */}
          <label style={{ fontWeight: "bold", padding: "0.4rem" }}>
            Autres Generaux
          </label>
        </td>
        <td colSpan="25%">
          <textarea
            rows="4"
            cols="42"
            style={{ borderRadius: "0.3rem" }}
            defaultValue={Newstate.GenerauxautresCom}
            name="GenerauxautresCom"
            onChange={handleChange}
          />
        </td>
      </tr>
    ),
  };
  const Familiaux = {
    glaucome: (
      <tr
        style={{
          borderRadius: "2rem",
        }}
      >
        <td
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        // colSpan="25%"
        >
          {/* <input
                        style={{ "lineHeight": "0.3rem", "verticalAlign": "-0.2rem", "marginRight": "0.9rem" }}
                        type="checkbox" onChange={ handleChange }
                        // hidden={true}
                        checked={Newstate.FamiliauxVisibleglaucome}
                        name='FamiliauxVisibleglaucome'
                    /> */}
          <label style={{ fontWeight: "bold", padding: "0.4rem" }}>
            Glaucome
          </label>
        </td>
        <td colSpan="25%">
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.FamiliauxVisibleglaucome}
            name="FamiliauxVisibleglaucome"
          />
        </td>
      </tr>
    ),
    keratocone: (
      <tr
        style={{
          borderRadius: "2rem",
        }}
      >
        <td
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        // colSpan="25%"
        >
          {/* <input
                        style={{ "lineHeight": "0.3rem", "verticalAlign": "-0.2rem", "marginRight": "0.9rem" }}
                        type="checkbox" onChange={ handleChange }
                        // hidden={true}
                        checked={Newstate.FamiliauxVisiblekeratocone}
                        name='FamiliauxVisiblekeratocone'
                    /> */}
          <label style={{ fontWeight: "bold", padding: "0.4rem" }}>
            Kératocone
          </label>
        </td>
        <td colSpan="25%">
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.FamiliauxVisiblekeratocone}
            name="FamiliauxVisiblekeratocone"
          />
        </td>
      </tr>
    ),
    strabisme: (
      <tr
        style={{
          borderRadius: "2rem",
        }}
      >
        <td
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        // colSpan="25%"
        >
          {/* <input
                        style={{ "lineHeight": "0.3rem", "verticalAlign": "-0.2rem", "marginRight": "0.9rem" }}
                        type="checkbox" onChange={ handleChange }
                        // hidden={true}
                        checked={Newstate.FamiliauxVisiblestrabisme}
                        name='FamiliauxVisiblestrabisme'
                    /> */}
          <label style={{ fontWeight: "bold", padding: "0.4rem" }}>
            Strabisme
          </label>
        </td>
        <td colSpan="25%">
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            // name="strabisme"
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.FamiliauxVisiblestrabisme}
            name="FamiliauxVisiblestrabisme"
          />
        </td>
      </tr>
    ),
    ametropie_forte: (
      <tr
        style={{
          borderRadius: "2rem",
        }}
      >
        <td
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        // colSpan="25%"
        >
          {/* <input
                        style={{ "lineHeight": "0.3rem", "verticalAlign": "-0.2rem", "marginRight": "0.9rem" }}
                        type="checkbox" onChange={ handleChange }
                        // hidden={true}
                        checked={Newstate.FamiliauxVisibleAmetropie_forte}
                        name='FamiliauxVisibleAmetropie_forte'
                    /> */}
          <label style={{ fontWeight: "bold", padding: "0.4rem" }}>
            Amétropie forte
          </label>
        </td>
        <td colSpan="25%">
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.FamiliauxVisibleAmetropie_forte}
            name="FamiliauxVisibleAmetropie_forte"
          />
        </td>
      </tr>
    ),
    retinopathie: (
      <tr
        style={{
          borderRadius: "2rem",
        }}
      >
        <td
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        // colSpan="25%"
        >
          {/* <input
                        style={{ "lineHeight": "0.3rem", "verticalAlign": "-0.2rem", "marginRight": "0.9rem" }}
                        type="checkbox" onChange={ handleChange }
                        // hidden={true}
                        checked={Newstate.FamiliauxVisibleretinopathie}
                        name='FamiliauxVisibleretinopathie'
                    /> */}
          <label style={{ fontWeight: "bold", padding: "0.4rem" }}>
            Rétinopathie
          </label>
        </td>
        <td colSpan="25%">
          <input
            style={{ lineHeight: "0.3rem", verticalAlign: "-0.2rem" }}
            // name="retinopathie"
            type="checkbox"
            onChange={handleChange}
            checked={Newstate.FamiliauxVisibleretinopathie}
            name="FamiliauxVisibleretinopathie"
          />
        </td>
      </tr>
    ),
    autresFamiliaux: (
      <tr
        style={{
          borderRadius: "2rem",
        }}
      >
        <td
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {/* <input
                        style={{ "lineHeight": "0.3rem", "verticalAlign": "-0.2rem", "marginRight": "0.9rem" }}
                        type="checkbox" onChange={ handleChange }
                        // hidden={true}
                        checked={Newstate.FamiliauxVisibleautres}
                        name='FamiliauxVisibleautres'
                    /> */}
          <label style={{ fontWeight: "bold", padding: "0.4rem" }}>
            Autres Familiaux
          </label>
        </td>
        <td colSpan="25%">
          <textarea
            rows="4"
            cols="42"
            style={{ borderRadius: "0.3rem" }}
            defaultValue={Newstate.FamiliauxautresCom}
            name="FamiliauxautresCom"
            onChange={handleChange}
          />
        </td>
      </tr>
    ),
  };

  let headerOphtalmo;

  if (
    Newstate.OphtalmoVisibleametropieForte ||
    Newstate.OphtalmoVisibleastigmatisme ||
    Newstate.OphtalmoVisibleautomedication_collyre ||
    Newstate.OphtalmoVisibledecollement_de_retine ||
    Newstate.OphtalmoVisibleglaucome ||
    Newstate.OphtalmoVisiblehypermetropie ||
    Newstate.OphtalmoVisibleivt_anti_vegf ||
    Newstate.OphtalmoVisiblekeratcone ||
    Newstate.OphtalmoVisiblemyopie ||
    Newstate.OphtalmoVisibleretinopathie_diabetique ||
    Newstate.OphtalmoVisiblestrabisme ||
    Newstate.OphtalmoVisibletraitement_amblyopie ||
    Newstate.OphtalmoVisibletraumatisme_oculaire ||
    Newstate.OphtalmoVisibletravail_prolongee_en_vp
    // ||
    // OphtalmoVisibleautres
  ) {
    headerOphtalmo = (
      <tr>
        <td colSpan="100%" className="headerClass">
          Antécédents Personnels Ophtalmologiques
        </td>
      </tr>
    );
  }
  let headerOphtalmo2;

  if (
    Newstate.OphtalmoVisiblechir_glaucome ||
    Newstate.OphtalmoVisiblechir_pterygion ||
    Newstate.OphtalmoVisiblechir_strabisme ||
    Newstate.OphtalmoVisiblechirurgie_de_cataracte ||
    Newstate.OphtalmoVisiblechirurgie_palpebrale ||
    Newstate.OphtalmoVisiblechirurgie_refractive ||
    Newstate.OphtalmoVisiblechirurgie_vitreo_retinienne ||
    Newstate.OphtalmoVisiblelaser_dehiscences_retinienne ||
    Newstate.OphtalmoVisibleppr ||
    Newstate.OphtalmoVisibledcrs
  ) {
    headerOphtalmo2 = (
      <tr>
        <td colSpan="100%" className="headerClass">
          Antécédents Personnels Oph. chirurgicaux
        </td>
      </tr>
    );
  }
  let headerGeneraux;
  if (
    Newstate.GenerauxVisiblecardiopathie ||
    Newstate.GenerauxVisibleallergies ||
    Newstate.GenerauxVisibletabac ||
    Newstate.GenerauxVisibledysthyroidie ||
    Newstate.GenerauxVisibleobesite ||
    Newstate.GenerauxVisibledyslipidemie ||
    Newstate.GenerauxVisiblegrossesse ||
    Newstate.GenerauxVisibleanticoagulants ||
    Newstate.GenerauxVisibleasthme ||
    Newstate.GenerauxVisiblehta ||
    Newstate.GenerauxVisiblediabete ||
    Newstate.GenerauxVisibleautres
  ) {
    headerGeneraux = (
      <tr>
        <td colSpan="100%" className="headerClass">
          {" "}
          Antécédents Personnels Généraux
        </td>
      </tr>
    );
  }

  let headerFamiliaux;

  if (
    Newstate.FamiliauxVisibleAmetropie_forte ||
    Newstate.FamiliauxVisibleautres ||
    Newstate.FamiliauxVisibleglaucome ||
    Newstate.FamiliauxVisiblekeratocone ||
    Newstate.FamiliauxVisibleretinopathie ||
    Newstate.FamiliauxVisiblestrabisme
  ) {
    headerFamiliaux = (
      <tr>
        <td colSpan="100%" className="headerClass">
          Antécédents Familiaux
        </td>
      </tr>
    );
  }

  const {
    autresGeneraux,
    cardiopathie,
    allergies,
    tabac,
    dysthyroidie,
    obesite,
    dyslipidemie,
    grossesse,
    anticoagulants,
    asthme,
    hta,
    diabete,
  } = Generaux;

  const {
    ametropie_forte,
    autresFamiliaux,
    glaucome,
    keratocone,
    retinopathie,
    strabisme,
  } = Familiaux;

  const {
    ametropieForte,
    astigmatisme,
    automedication_par_collyre,
    chir_glaucome,
    chir_pterygion,
    chir_strabisme,
    chirurgie_de_cataracte,
    chirurgie_palpebrale,
    chirurgie_refractive,
    chirurgie_vitreo_retinienne,
    dcrs,
    decollement_de_retine,
    glaucomeOphtalmo,
    hypermetropie,
    ivt_anti_vegf,
    keratcone,
    laser_dehiscences_retinienne,
    myopie,
    ppr,
    retinopathie_diabetique,
    strabismeOphtalmo,
    traitement_amblyopie,
    traumatisme_oculaire,
    travail_prolongee_en_vp,
    autresOphtalmologiques,
  } = Ophtalmologiques;

  return (
    <div
      style={{
        // "Width": "10vw",
        // "height": "44vh",
        overflowY: "scroll",
        overflow: "auto",
        // "marginBottom": "1rem",
      }}
      className="tableauAntecedents"
    >
      {/* <div style={{
                "display": "flex",
                "justifyContent": "space-around",
                "backgroundColor": "#f2f2f2",
                "borderRadius": "3rem"
            }} > */}
      {/* <Button.Group > */}
      {/* <Button
          color="black"
          onClick={() => dispatch({ type: ACTION.OPEN, size: "large" })}
        >
          +
        </Button> */}
      <Popup
        content="Ajouter un antécédent"
        trigger={
          <Icon
            circular
            inverted
            color="black"
            floated="left"
            onClick={() => dispatch({ type: ACTION.OPEN, size: "large" })}
            name="add"
            size="large"
          // className="centerIcon_And_Float_Right"
          />
        }
      />
      <Modal
        size={state.size}
        open={state.open}
        onClose={() => dispatch({ type: ACTION.CLOSE })}
      >
        <Modal.Header className="centerItemTitre">
          Ajouter un ou plusieurs Antécédents
        </Modal.Header>
        <Modal.Content>{count > 0 ? menuQuestions : null}</Modal.Content>
        <Modal.Actions>
          <Button color="blue" onClick={() => dispatch({ type: ACTION.CLOSE })}>
            Retour
          </Button>
        </Modal.Actions>
      </Modal>

      {/* </div> */}

      <table
        id={MakeTableGreatAgain}
        style={{
          borderCollapse: "collapse",
          borderRadius: "1em",
          overflow: "hidden",
        }}
      >
        <tbody>
          {headerOphtalmo ? headerOphtalmo : null}
          {Newstate.OphtalmoVisibleametropieForte ? ametropieForte : null}
          {Newstate.OphtalmoVisibleastigmatisme ? astigmatisme : null}
          {Newstate.OphtalmoVisiblemyopie ? myopie : null}

          {Newstate.OphtalmoVisibleautomedication_collyre
            ? automedication_par_collyre
            : null}

          {Newstate.OphtalmoVisibledecollement_de_retine
            ? decollement_de_retine
            : null}
          {Newstate.OphtalmoVisibleglaucome ? glaucomeOphtalmo : null}
          {Newstate.OphtalmoVisiblehypermetropie ? hypermetropie : null}
          {Newstate.OphtalmoVisiblekeratcone ? keratcone : null}
          {Newstate.OphtalmoVisibleretinopathie_diabetique
            ? retinopathie_diabetique
            : null}
          {Newstate.OphtalmoVisiblestrabisme ? strabismeOphtalmo : null}
          {Newstate.OphtalmoVisibletraumatisme_oculaire
            ? traumatisme_oculaire
            : null}
          {Newstate.OphtalmoVisibleivt_anti_vegf ? ivt_anti_vegf : null}
          {Newstate.OphtalmoVisibletraitement_amblyopie
            ? traitement_amblyopie
            : null}
          {Newstate.OphtalmoVisibletravail_prolongee_en_vp
            ? travail_prolongee_en_vp
            : null}
          {/* {OphtalmoVisibleautres ? autresOphtalmologiques : null} */}

          {headerOphtalmo2 ? headerOphtalmo2 : null}
          {Newstate.OphtalmoVisiblechir_glaucome ? chir_glaucome : null}
          {Newstate.OphtalmoVisiblechir_pterygion ? chir_pterygion : null}
          {Newstate.OphtalmoVisiblechir_strabisme ? chir_strabisme : null}
          {Newstate.OphtalmoVisiblechirurgie_de_cataracte
            ? chirurgie_de_cataracte
            : null}
          {Newstate.OphtalmoVisiblechirurgie_palpebrale
            ? chirurgie_palpebrale
            : null}
          {Newstate.OphtalmoVisiblechirurgie_refractive
            ? chirurgie_refractive
            : null}
          {Newstate.OphtalmoVisiblechirurgie_vitreo_retinienne
            ? chirurgie_vitreo_retinienne
            : null}
          {Newstate.OphtalmoVisibledcrs ? dcrs : null}
          {Newstate.OphtalmoVisibleppr ? ppr : null}
          {Newstate.OphtalmoVisiblelaser_dehiscences_retinienne
            ? laser_dehiscences_retinienne
            : null}

          {headerGeneraux ? headerGeneraux : null}

          {Newstate.GenerauxVisiblecardiopathie ? cardiopathie : null}
          {Newstate.GenerauxVisibleallergies ? allergies : null}
          {Newstate.GenerauxVisibletabac ? tabac : null}
          {Newstate.GenerauxVisibledysthyroidie ? dysthyroidie : null}
          {Newstate.GenerauxVisibleobesite ? obesite : null}
          {Newstate.GenerauxVisibledyslipidemie ? dyslipidemie : null}
          {Newstate.GenerauxVisiblegrossesse ? grossesse : null}
          {Newstate.GenerauxVisibleanticoagulants ? anticoagulants : null}
          {Newstate.GenerauxVisibleasthme ? asthme : null}
          {Newstate.GenerauxVisiblehta ? hta : null}
          {Newstate.GenerauxVisiblediabete ? diabete : null}
          {Newstate.GenerauxVisibleautres ? autresGeneraux : null}

          {headerFamiliaux ? headerFamiliaux : null}

          {Newstate.FamiliauxVisibleAmetropie_forte ? ametropie_forte : null}

          {Newstate.FamiliauxVisibleglaucome ? glaucome : null}
          {Newstate.FamiliauxVisiblekeratocone ? keratocone : null}
          {Newstate.FamiliauxVisibleretinopathie ? retinopathie : null}
          {Newstate.FamiliauxVisiblestrabisme ? strabisme : null}
          {Newstate.FamiliauxVisibleautres ? autresFamiliaux : null}
          <tr>
            <td colSpan="100%" className="headerClass">
              Autres
            </td>
          </tr>
          {autresOphtalmologiques}
        </tbody>
      </table>
    </div>
  );
}

export default FormulairesAntecedents;
